import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatChipsModule } from '@angular/material/chips';
import { TranslateModule } from '@ngx-translate/core';
import { AvatarCardModule } from '@app/common/avatar-card';
import { UserCardComponent } from './user-card.component';
import { WrapEmailAddressAtModule } from '../wrap-email-address-at';

@NgModule({
  declarations: [ UserCardComponent ],
  imports: [
    CommonModule,
    FlexLayoutModule,
    MatCardModule,
    MatIconModule,
    MatTooltipModule,
    MatChipsModule,
    TranslateModule.forChild(),
    AvatarCardModule,
    WrapEmailAddressAtModule
  ],
  exports: [ UserCardComponent ]
})
export class UserCardModule { }
